import React from 'react';

const RegistrationCompleteForm = () => {
    return (
        <React.Fragment>
            <h1>Your account was created</h1>
            <div>
                <h2>Thank you for registering.</h2>
                <p style={{marginTop: '1rem'}}>
                    You will receive a confirmation email shortly. <b>Before your account can be used you will need to click on the activation link in that message.</b>
                </p>
            </div>
        </React.Fragment>
    )
}

export default RegistrationCompleteForm